import React, { Component } from 'react';
import Bounce from 'react-reveal/Bounce';
import { Link } from 'react-router-dom';

class Download extends Component {
	render() {
		return (
			<div>
				<section className="hero is-info download" id="download" name="scroll-to-download">
					<div className="hero-body">
						<div className="container ">
							<div className="columns is-desktop">
								<div className="column is-half">
									<Bounce left>
										<h1 className="title">Download Deliv Now</h1>
										<h2 className="subtitle">Coba dan rasakan menggunakan layanan kami</h2>
									</Bounce>
								</div>
								<div className=" column is-flex is-vcentered is-horizontal-center">
									<Bounce right>
										<a href="https://s.id/31FSI">
											<img className="image" src="/img/btn/play-store.png" alt="playstore" />
										</a>
										
										<a href="/registrasi">
										<Link to="/registrasi"  ><img className="image" src="/img/btn/join-deliv.png" alt="deliv" /></Link>
										</a>
									</Bounce>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default Download;
